import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { Button } from "@connect/component-library/components/button";
export const CtaButton = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      variant: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const variant = t1 === undefined ? "inverted" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = clsx(className, "rounded-full");
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t2 || $[8] !== variant) {
    t3 = <Button variant={variant} className={t2} {...props} />;
    $[6] = props;
    $[7] = t2;
    $[8] = variant;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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